<template>
    <counsel-card-row label="기간">
        <v-row class="row--small">
            <v-col cols="6" lg="3">
                <v-text-field v-model="value.startsAt" label="시작일" v-bind="inputProps" />
            </v-col>
            <v-col cols="6" lg="3">
                <v-text-field v-model="value.endsAt" label="종료일" v-bind="inputProps" />
            </v-col>
        </v-row>
    </counsel-card-row>
</template>

<script>
import dayjs from "dayjs";
import counselCardRow from "./counsel-card-row.vue";
const inputProps = {
    type: "date",
    outlined: true,
    "hide-details": true,
    dense: true,
};
export default {
    components: { counselCardRow },
    props: ["value"],
    data() {
        return {
            inputProps,
        };
    },
    mounted() {
        const startsAt = dayjs().format("YYYY-MM-DD");
        const endsAt = dayjs()
            .add(3, "months")
            .format("YYYY-MM-DD");
        this.$emit("input", { ...this.value, startsAt, endsAt });
    },
};
</script>

<style></style>
